import { useRouter } from "next/router";
import React from "react";
import styles from "../../styles/Tech.module.css";

const BlogCardTechFeatured = ({ title, img, date, desc, alt, slug }) => {
    const router = useRouter();
    return (
        <div
            className={`flex items-center justify-center  mt-10 mr-20 relative cursor-pointer ${styles.blog_featured}`}
            onClick={() => router.push(`/blog/${slug}/`)}
        >
            <div className={styles.blog_featured_img}>
                <img
                    src={img}
                    alt={alt}
                    width="150"
                    height="600"
                    sizes="(max-width: 500px) 50vw,
        (max-width: 1200px) 70vw,
        100vw"
                />
            </div>
            <div className={styles.blog_featured_top}>
                <div className={`flex items-center ${styles.blog_featured_title}`}>
                    <svg className="mr-2 w-[28px]" height="20" width="20">
                        <circle cx="10" cy="10" r="7" stroke="black" strokeWidth="0.5" fill="#C30B0B" />
                    </svg>
                    <h5>{title}</h5>
                </div>
            </div>

            <div className={styles.blog_featured_img_grd} onClick={() => router.push(`/blog/${slug}/`)}>
                <p>{desc}</p>
                <div className="flex justify-between">
                    <p className="text-sm mb-2">{date}</p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="4"
                        stroke="currentColor"
                        className="w-4 h-4 ml-3 cursor-pointer"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default BlogCardTechFeatured;
